import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card-wrapper"
}
const _hoisted_2 = {
  key: 1,
  class: "card-wrapper"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "impact-section" }
const _hoisted_7 = { class: "buttons-container" }

import ResumeBase from "@/Layouts/ResumeBase/ResumeBase.vue";
import AppButton from "@/components/Common/AppButton/AppButton.vue";
import PreviewCard from "@/components/Resume/PreviewCard/PreviewCard.vue";
import { useResumeStore } from "@/store";
import { onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import {
  convertToMonthYear,
  sortWorkExperiences,
  focusOnMainContent,
} from "@/helpers";
import { onIonViewDidEnter } from "@ionic/vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'ResumeWorkExperiences',
  setup(__props) {

const resumeStore = useResumeStore();
const router = useRouter();
const route = useRoute();

onIonViewDidEnter(() => {
  focusOnMainContent(route?.meta?.mainContentId);
});

onMounted(async () => {
  if (!resumeStore.resumeId) {
    await resumeStore.requestResume();
    if (!resumeStore.resumeId) {
      await resumeStore.createResume();
    }
  }
});

function addWorkExperience() {
  resumeStore.initWorkExperienceForm();
  router.push({
    name: "ResumeWorkExperienceDetail",
    params: { id: "new" },
  });
}

function editWorkExperience(id: string) {
  resumeStore.initWorkExperienceForm(id);
  router.push({
    name: "ResumeWorkExperienceDetail",
    params: { id: id },
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ResumeBase, {
    breadcrumbs: [
      {
        route: 'employment-history',
        label: _ctx.$t('resume.breadcrumbs.workExperiences'),
      },
    ],
    mainContentId: "resume-work-experiences-main-content",
    skipOnRouteBeforeLeave: true
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t("resume.workExperiences.title")), 1)
    ]),
    description: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t("resume.workExperiences.description")), 1)
    ]),
    "main-content": _withCtx(() => [
      (_unref(resumeStore).isResumeLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (item) => {
              return _createElementVNode("div", {
                class: "card-item",
                key: item
              }, [
                _createVNode(PreviewCard, { isLoading: true })
              ])
            }), 64))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortWorkExperiences)(
            _unref(resumeStore)?.resume?.workExperiences
          ), (experience) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "card-item",
                key: experience.id
              }, [
                _createVNode(PreviewCard, {
                  id: experience.id,
                  title: experience.role,
                  isLoading: _unref(resumeStore).isResumeLoading,
                  "data-test": "preview-card",
                  "button-text": _ctx.$t('resume.workExperiences.editButton'),
                  onClick: ($event: any) => (editWorkExperience(experience.id))
                }, {
                  metadata: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(experience.business), 1),
                    _createElementVNode("p", null, [
                      _createTextVNode(_toDisplayString(_unref(convertToMonthYear)(experience.startDate, _ctx.$t)) + " ", 1),
                      (
                    experience.startDate &&
                    (experience.endDate || experience.isCurrentRole)
                  )
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, " - "))
                        : _createCommentVNode("", true),
                      (experience.isCurrentRole)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t("resume.workExperiences.presentLabel")), 1))
                        : (experience.endDate)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(convertToMonthYear)(experience.endDate, _ctx.$t)), 1))
                          : _createCommentVNode("", true)
                    ])
                  ]),
                  description: _withCtx(() => [
                    _createElementVNode("p", _hoisted_6, _toDisplayString(experience.impact), 1)
                  ]),
                  _: 2
                }, 1032, ["id", "title", "isLoading", "button-text", "onClick"])
              ]))
            }), 128))
          ])),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(AppButton, {
          size: "default",
          type: "primary",
          label: _ctx.$t('resume.workExperiences.addButton'),
          ariaLabel: _ctx.$t('resume.workExperiences.addButton'),
          "data-test": "add-btn",
          onClick: addWorkExperience,
          width: "100%",
          showLoadingSkeleton: _unref(resumeStore).isResumeLoading
        }, null, 8, ["label", "ariaLabel", "showLoadingSkeleton"]),
        _createVNode(AppButton, {
          size: "default",
          type: "secondary",
          label: _ctx.$t('resume.workExperiences.returnButtonText'),
          ariaLabel: _ctx.$t('resume.workExperiences.returnButtonText'),
          "data-test": "return-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'ResumeOverview' }))),
          width: "100%",
          showLoadingSkeleton: _unref(resumeStore).isResumeLoading
        }, null, 8, ["label", "ariaLabel", "showLoadingSkeleton"])
      ])
    ]),
    "resume-helper": _withCtx(() => [...(_cache[1] || (_cache[1] = []))]),
    _: 1
  }, 8, ["breadcrumbs"]))
}
}

})